// extracted by mini-css-extract-plugin
export default {"container":"notFound_container__bX0DD","h2":"notFound_h2__Tp6bM","span":"notFound_span__p1VGW","animate":"notFound_animate__zLFx9"};